import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchOrderHistoryDetailed } from "../../../api/api";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const UpdatedHistoryDetails = () => {
  const { t } = useTranslation();
  const { billNo, cnt } = useParams<{ billNo: string; cnt: string }>();
  const [order, setOrder] = useState<{ master: any[]; table: any[] }>({
    master: [],
    table: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadHistoryDetails = async () => {
      if (!billNo || !cnt) return;
      try {
        const res = await fetchOrderHistoryDetailed(billNo, Number(cnt));
        setOrder(res);
      } catch (error) {
        console.error("Error loading history details:", error);
      } finally {
        setLoading(false);
      }
    };
    loadHistoryDetails();
  }, [billNo, cnt]);

  if (loading) return <p>Loading...</p>;
  if (!order.table || order.table.length === 0)
    return <p>No history details found.</p>;

  //  bill header comes from table[0]
  const bill = order.table[0];

  return (
    <div className="page-wrapper">
      <div
        className="content container-fluid"
        style={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}
      >
        <h4 className="mb-4">
          {t("orderHistoryDetails")} - {bill.BillNo} (Edit {cnt})
        </h4>

        {/* Bill Header */}
        <div className="row mb-4">
          <div className="col-md-6 mb-3">
            <strong>{t("billNo")}:</strong> {bill.BillNo}
          </div>
          <div className="col-md-6 mb-3">
            <strong>{t("partyName")}:</strong> {bill.BillPartyName}
          </div>
          <div className="col-md-6 mb-3">
            <strong>{t("date")}:</strong>{" "}
            {dayjs(bill.changed_time).format("YYYY-MM-DD HH:mm")}
          </div>
          <div className="col-md-6 mb-3">
            <strong>{t("netTotal")}:</strong> ₹{bill.BillNetTotalField}
          </div>
          <div className="col-md-6 mb-3">
            <strong>{t("user")}:</strong> {bill.user_name}
          </div>
          <div className="col-md-6 mb-3">
            <strong>{t("contact")}:</strong> {bill.CashCardAmt}
          </div>
          <div className="col-md-6 mb-3">
            <strong>{t("dealer")}:</strong> {bill.dealer}
          </div>
          <div className="col-md-6 mb-3">
            <strong>{t("warehouse")}:</strong> {bill.warehouse}
          </div>
        </div>

        {/* Items */}
        {order.master.length > 0 && (
          <div className="mt-4">
            <h5>{t("salesItems")}</h5>
            <div
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                overflowX: "auto",
              }}
            >
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>{t("itemCode")}</th>
                    <th>{t("itemName")}</th>
                    <th>{t("qty")}</th>
                    <th>{t("rate")}</th>
                    <th>{t("total")}</th>
                    <th>{t("discountPercent")}</th>
                    <th>{t("discountAmount")}</th>
                    <th>{t("taxPercent")}</th>
                    <th>{t("taxAmount")}</th>
                    <th>{t("netTotal")}</th>
                    <th>{t("godown")}</th>
                    <th>{t("pack")}</th>
                    <th>{t("unit")}</th>
                    <th>{t("cost")}</th>
                    <th>{t("batch")}</th>
                    <th>{t("mrp")}</th>
                    <th>{t("expiry")}</th>
                    <th>{t("delete")}</th>
                  </tr>
                </thead>
                <tbody>
                  {order.master.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.ItemC}</td>
                      <td>{item.Item}</td>
                      <td>{item.Qty}</td>
                      <td>{item.Rate}</td>
                      <td>{item.Total}</td>
                      <td>{item.Dis}</td>
                      <td>{item.TaxP}</td>
                      <td>{item.ItWiseDisAmt}</td>
                      <td>{item.TaxA}</td>
                      <td>{item.NetV}</td>
                      <td>{order.table[0]?.godown}</td>
                      <td>{item.Pack}</td>
                      <td>{item.Unit}</td>
                      <td>{item.Cst}</td>
                      <td>{item.batch_no}</td>
                      <td>{item.Mrp}</td>
                      <td>{item.expiry}</td>
                      <td>{item.Stat}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* 2nd form */}
        <div className="row mt-4">
          {/* Dis Amt */}
          <div className="col-md-6 mb-3">
            <strong>{t("Dis Amt")}:</strong> {bill.BillDiscAmtField}
          </div>

          {/* Dis % */}
          <div className="col-md-6 mb-3">
            <strong>{t("Dis %")}:</strong> {bill.BillDiscPercField}
          </div>

          {/* Tax % */}
          <div className="col-md-6 mb-3">
            <strong>{t("Tax %")}:</strong> {order.master[0]?.TaxP || 0}
          </div>

          {/* Tax Amt */}
          <div className="col-md-6 mb-3">
            <strong>{t("Tax Amt")}:</strong> {bill.TAmt || 0}
          </div>

          {/* Trans & Other */}
          <div className="col-md-6 mb-3">
            <strong>{t("Trans & Other")}:</strong> {bill.BillPackageField || "-"}
         </div>
          
          {/* Net Total */}
          <div className="col-md-6 mb-3">
            <strong>{t("Net Total")}:</strong> ₹{bill.BillNetTotalField}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatedHistoryDetails;
